import { render, staticRenderFns } from "./EstanquesExternos.vue?vue&type=template&id=60951bc0&"
import script from "./EstanquesExternos.vue?vue&type=script&lang=js&"
export * from "./EstanquesExternos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports